import { render, staticRenderFns } from "./FeedbackAverage.vue?vue&type=template&id=39a68ad8"
import script from "./FeedbackAverage.vue?vue&type=script&lang=js"
export * from "./FeedbackAverage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports